// extracted by mini-css-extract-plugin
export default {"form":"CountryRuleForm_form__EqY7A","form__button":"CountryRuleForm_form__button__YxoOp"};